
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/hooks/useAuth';
import { useRole } from '@/hooks/useRole';
import { logger } from '@/utils/logger';

export function RoleSelectionBanner() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();
  const { user } = useAuth();
  const { role, loading: roleLoading } = useRole();
  
  // Don't show banner if we're still loading role information
  if (roleLoading) {
    return null;
  }
  
  // Don't show banner if user already has a role
  if (role) {
    logger.debug("User already has role:", role, "- not showing role selection banner");
    return null;
  }
  
  const handleSelectRole = () => {
    if (!user) {
      toast({
        title: "Login Required",
        description: "Please sign in to select your role.",
      });
      return;
    }
    
    logger.debug("Navigating to role selection page");
    setLoading(true);
    
    // Navigate to the role selection page
    navigate('/select-role');
  };

  return (
    <div className="bg-yellow-100 dark:bg-yellow-900/30 border border-yellow-300 dark:border-yellow-700 p-3 rounded-lg mb-4">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
        <div>
          <h3 className="font-semibold text-yellow-800 dark:text-yellow-300">Complete Your Profile</h3>
          <p className="text-sm text-yellow-700 dark:text-yellow-400">
            Please select your role to access all features
          </p>
        </div>
        <Button 
          size="sm" 
          onClick={handleSelectRole}
          disabled={loading}
          className="bg-yellow-500 hover:bg-yellow-600 text-white"
        >
          {loading ? "Loading..." : "Set Role Now"}
        </Button>
      </div>
    </div>
  );
}
